import gql from "graphql-tag";

export const getUserQuery = gql(`
query GetUser($email: String!, $token: String!) {
    getUser(email: $email, token: $token) {
        email
        organizations
        fullName
        authenticated
        role
    }
}
`);


export const SOUND_FILE_FIELDS = `
    fragment SoundFileFields on SoundFile {
                    originalFileName,
                    fileName,
                    filePath,
                    ambient,
                    playOnes,
                    keepPlayingAfterMainFile,
                    fadeIn,
                    fadeOut,
                    delay,
                    synchronize,
                    noSyncTime,
                    language,
                    volumeDb
                }
`;


export const SPOT_FIELDS = `
	fragment SpotFields on Spot {
		id,
		areaId,
        name,
        summary,
        description,
        coverImageUrl,
        note,
        type,
        priority,
        beaconSensitivity,
        canBeStopped,
        externalIdentifier,
        pauseOtherAmbients,
        duckOtherAmbients,
        duckOtherAmbientsDb,
        followMainSound,
        synchronizeEntry,
        playMode,
        playFullAfter,
        loop,
        runOnes,
        modifiedAt,
        key,
        soundFiles {
                ...SoundFileFields
        },
        beaconTriggers {
            id
            type
            macAddr
            majorId
            minorId
            uuid
            note
            }
        wiFiTriggers {
            id
            type
            name
        }
        gpsTriggers {
            id
            type
            shapeType
            polygonCoords {
                lat
                lng
            }
            circleRadius
        }
        triggerRules {
            rules {
                id
                type
                eventType
                spotKey
                zoneKey
                minMsSinceFinished
                minMsSinceTriggered
            }
            logic
        }

    ...on MarkerSpot  {
            position {
                lat,
                    lng
            }
            
        },
        
    ...on CircleSpot {
            center {
                lat,
                    lng
            }
            radius
        },
        
    ...on PolygonSpot {
            coords {
                lat,
                    lng
            }
        }
	}
`;


export const getSpotsQuery = gql(`
${SOUND_FILE_FIELDS},
${SPOT_FIELDS},
query GetSpots($areaId: String!, $publishedAt: Float!) {
    getSpots(areaId: $areaId, publishedAt: $publishedAt) {
        ...SpotFields
    }
}
`);


export const createSpotMutation = gql(`
${SOUND_FILE_FIELDS},
${SPOT_FIELDS},
	mutation CreateMarkerSpot($type: String!, $areaId: String!, $name: String!, $position: LatLng!) {
		createMarkerSpot(type: $type, areaId: $areaId, name: $name, position: $position) {
			...SpotFields
	    }
	}
`);

export const createPolygonSpotMutation = gql(`
${SOUND_FILE_FIELDS},
${SPOT_FIELDS},
	mutation CreatePolygonSpot($type: String!, $areaId: String!, $name: String!, $coords: [LatLng!]!, $gpsTriggers: [GpsTriggerIn]) {
		createPolygonSpot(type: $type, areaId: $areaId, name: $name, coords: $coords, gpsTriggers: $gpsTriggers) {
			...SpotFields
	    }
	}
`);

export const updateMarkerSpotMutation = gql(`
${SOUND_FILE_FIELDS},
${SPOT_FIELDS},
	mutation UpdateMarkerSpot($id: String!, $areaId: String!, $type: String!, $name: String, $summary: String, $description: String, $coverImageUrl: String, $note: String,
	                                $position: LatLng, $priority: Int,$beaconSensitivity: Int, $playMode: String,
	                                $runOnes: Boolean, $canBeStopped: Boolean, $synchronizeEntry: Boolean, $externalIdentifier: String, $loop: Boolean!, $playFullAfter: Int,
	                                $pauseOtherAmbients: Boolean, $duckOtherAmbients: Boolean, $duckOtherAmbientsDb: Int, $followMainSound: Boolean,
	                                $soundFiles: [SoundFileIn], $beaconTriggers: [BeaconTriggerIn],
	                                $wiFiTriggers: [WiFiAPTriggerIn], $gpsTriggers: [GpsTriggerIn], $coords: [LatLng],
	                                $triggerRules: TriggerRulesIn, $key: String!, $modifiedAt: Float!, $expectedModifiedAt: Float
	                          ) {
		updateMarkerSpot(id: $id, areaId: $areaId, type: $type, name: $name, summary: $summary, description: $description, coverImageUrl: $coverImageUrl, note: $note, position: $position, priority: $priority, beaconSensitivity: $beaconSensitivity, playMode: $playMode,
		                runOnes: $runOnes, canBeStopped: $canBeStopped, synchronizeEntry: $synchronizeEntry, externalIdentifier: $externalIdentifier, loop: $loop, playFullAfter: $playFullAfter, pauseOtherAmbients: $pauseOtherAmbients, duckOtherAmbients: $duckOtherAmbients, duckOtherAmbientsDb: $duckOtherAmbientsDb, followMainSound: $followMainSound, soundFiles: $soundFiles,
		                beaconTriggers: $beaconTriggers, wiFiTriggers: $wiFiTriggers, gpsTriggers: $gpsTriggers, coords: $coords,
		                triggerRules: $triggerRules, key: $key, modifiedAt: $modifiedAt, expectedModifiedAt: $expectedModifiedAt
		             ) {
			...SpotFields
		}
	}
`);

export const updatePolygonSpotMutation = gql(`
${SOUND_FILE_FIELDS},
${SPOT_FIELDS},
	mutation UpdatePolygonSpot($id: String!, $areaId: String!, $type: String!, $name: String, $summary: String, $description: String, $coverImageUrl: String, $note: String,
	                                $coords: [LatLng], $priority: Int,$beaconSensitivity: Int, $playMode: String,
	                                $runOnes: Boolean, $canBeStopped: Boolean, $synchronizeEntry: Boolean, $externalIdentifier: String, $loop: Boolean!, $playFullAfter: Int,
	                                $pauseOtherAmbients: Boolean, $duckOtherAmbients: Boolean, $duckOtherAmbientsDb: Int, $followMainSound: Boolean,
	                                $soundFiles: [SoundFileIn], $beaconTriggers: [BeaconTriggerIn],
	                                $wiFiTriggers: [WiFiAPTriggerIn], $gpsTriggers: [GpsTriggerIn],
	                                $triggerRules: TriggerRulesIn, $key: String!, $modifiedAt: Float!, $expectedModifiedAt: Float
	                          ) {
		updatePolygonSpot(id: $id, areaId: $areaId, type: $type, name: $name, summary: $summary, description: $description, coverImageUrl: $coverImageUrl, note: $note, coords: $coords, priority: $priority, beaconSensitivity: $beaconSensitivity, playMode: $playMode,
		                runOnes: $runOnes, canBeStopped: $canBeStopped, synchronizeEntry: $synchronizeEntry, externalIdentifier: $externalIdentifier, loop: $loop, playFullAfter: $playFullAfter, pauseOtherAmbients: $pauseOtherAmbients, duckOtherAmbients: $duckOtherAmbients, duckOtherAmbientsDb: $duckOtherAmbientsDb, followMainSound: $followMainSound, soundFiles: $soundFiles,
		                beaconTriggers: $beaconTriggers, wiFiTriggers: $wiFiTriggers, gpsTriggers: $gpsTriggers,
		                triggerRules: $triggerRules, key: $key, modifiedAt: $modifiedAt, expectedModifiedAt: $expectedModifiedAt
		             ) {
			...SpotFields
		}
	}
`);

export const deleteSpotMutation = gql(`
	mutation DeleteSpot($id: String!) {
		deleteSpot(id: $id)
	}
`);

export const moveSpotToPositionMutation = gql(`
${SOUND_FILE_FIELDS},
${SPOT_FIELDS},
    mutation MoveSpotToPosition($areaId: String!, $spotKey: String!, $toPosition: Int!) {
        moveSpotToPosition(areaId: $areaId, spotKey: $spotKey, toPosition: $toPosition) {
            ...SpotFields
        }
    }
`);


export const AREA_ZONES = `
    fragment ZoneFields on Zone {
            id,
            name,
            label,
            beaconSensitivity,
            stopOtherAmbients,
            playMode,
            loop,
            runOnes,
            playFullAfter,
            resetApps,
            coolDownPeriod,
            markCompleted,
            triggerToActivate,
            triggerRules {
                rules {
                    id
                    type
                    eventType
                    spotKey
                    zoneKey
                    minMsSinceFinished
                    minMsSinceTriggered
                }
                logic
            },
            soundFiles {
                ambient {
                    ...SoundFileFields
                    },
                entry {
                    ...SoundFileFields
                    },
                exit {
                    ...SoundFileFields
                    },
            },
            beaconTriggers {
                id
                zoneId
                type
                macAddr
                majorId
                minorId
                uuid
                note
                }
            wiFiTriggers {
                id
                zoneId
                type
                name
            }
            gpsTriggers {
                id
                zoneId
                type
                shapeType
                polygonCoords {
                    lat
                    lng
                }
                circleRadius
            }
        }
`;
